// extracted by mini-css-extract-plugin
export default {"container":"input_container__hfZjQ","light":"input_light__5gaGc","dark":"input_dark__+2zoU"};